const content = `<b style="font-size: 2.2rem;">Privacy Policy for the Contact Form</b>

We are pleased about your interest in manny+nanny | THE BABYSITTER AGENCY, a business division of Lenssen GmbH. When you use our contact form, we process your personal data (e.g. your email address and, if applicable, your telephone number) in order to handle your message and contact you if necessary. In doing so, it is required that you agree to our linked General Terms and Conditions (GTC) as well as our linked Privacy Policy.

You can revoke your consent to store your email address and, if applicable, your telephone number at any time with effect for the future. Detailed information on data processing and your rights in accordance with the GDPR can be found in our complete Privacy Policy.
`

function PrivacyPolicyContactEn(props) {
    return (
        <div className="text_2_black" style={{whiteSpace: "pre-wrap"}} dangerouslySetInnerHTML={{__html: content}}/>
    );
}

export default PrivacyPolicyContactEn;
